import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/student-award',
    name: 'studentAward',
    component: () => import('@/views/student-award/StudentAward.vue'),
    meta: {
      pageTitle: 'Danh sách đạt khen thưởng',
      breadcrumb: [
        {
          text: 'Công tác Học sinh - Sinh viên',
          active: false,
        },
        {
          text: 'Danh sách đạt khen thưởng',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.STUDENTAWARD,
    },
  },
]
